import ProcessInventoryReceivingItemsModal from "./ProcessInventoryReceivingItemsModal";
export default ProcessInventoryReceivingItemsModal;
